import { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, HStack, rem } from '@bonusly/design-system';

import { RelevantHelper } from '../../../../components/celebrations/celebrations-widget/components/relevant-helper';
import { useMonthlyCelebrationsQuery } from '../../../../components/celebrations/celebrations-widget/hooks/use-celebrations-api';
import { Panel } from '../../../../components/panel';
import { PillTab } from '../../../../components/tabs/pill-tab';
import { PanelCelebrationsGroup } from './panel-celebrations-group';

interface CelebrationsPanelProps {
	isOpen: boolean;
	isSidebarExpanded: boolean;
	onClose: () => void;
}

export const CelebrationsPanel: FC<CelebrationsPanelProps> = ({ isOpen, isSidebarExpanded, onClose }) => {
	const { t } = useTranslation(['navigation', 'celebrations']);
	const { data, error, isLoading } = useMonthlyCelebrationsQuery();
	const scrollRef = useRef<HTMLDivElement>(null);
	const [activeTab, setActiveTab] = useState<'relevant' | 'all'>('relevant');

	return (
		<Panel
			isOpen={isOpen}
			onClose={onClose}
			isSidebarExpanded={isSidebarExpanded}
			title={t('celebrations:modal.header')}
			closeButtonLabel={t('navigation:celebrationsPanel.close')}
			width={rem(350)}
			data-testid="celebrations-panel"
			scrollRef={scrollRef}
			subheader={
				<HStack spacing={2} px={2} pb={3}>
					<PillTab isActive={activeTab === 'relevant'} onClick={() => setActiveTab('relevant')} px={4} py={1.5}>
						{t('celebrations:modal.relevant_tab')}
					</PillTab>
					<PillTab isActive={activeTab === 'all'} onClick={() => setActiveTab('all')} px={4} py={1.5}>
						{t('celebrations:modal.all_tab')}
					</PillTab>
				</HStack>
			}
		>
			<Box px={2}>
				{activeTab === 'relevant' && (
					<>
						<PanelCelebrationsGroup celebrations={data.relevant} hasError={!!error} isLoading={isLoading} onClose={onClose} />
						{!isLoading && !error && data.relevant.count > 0 && <RelevantHelper />}
					</>
				)}
				{activeTab === 'all' && <PanelCelebrationsGroup celebrations={data.all} hasError={!!error} isLoading={isLoading} onClose={onClose} />}
			</Box>
		</Panel>
	);
};
